import { IconShieldCheck } from "@tabler/icons-react";

type BadgeLevel = "iniciante" | "intermediario" | "maximo" | "ametista";

interface BadgeProps {
  label: string;
  level?: BadgeLevel;
}

export default function Badge({ label, level = "iniciante" }: BadgeProps) {
  const baseClasses = "badge-base inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-sm font-medium shadow-sm";

  const levelClasses: Record<BadgeLevel, string> = {
    iniciante: "badge-iniciante",
    intermediario: "badge-intermediario",
    maximo: "badge-maximo",
    ametista: "badge-ametista",
  };

  return (
    <div className={`${baseClasses} ${levelClasses[level]}`}>
      <IconShieldCheck size={16} stroke={2} />
      <span>Nivel: {label}</span>
    </div>
  );
}
